import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { isFunction, noop } from 'lodash';
import { INDICATION_TYPES, removeIndication } from '../modules/taboola-common-frontend-modules/Indications';
import { useMultiLayerDrawerEnabled } from '../modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { useDrawerStack } from './queryParams/useDrawerStack';
import { useNavigate } from './useNavigate';

export const useHandleModuleNavigation = ({ path, gtmCallback = noop }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();
    const { pop } = useDrawerStack();

    //TODO: DEV-167693 remove this file and support in FormLayout only pop when isMultiLayerDrawerEnabled is on for all
    const handleNavigation = useCallback(
        cancelFunc => {
            gtmCallback();
            if (isFunction(cancelFunc)) {
                cancelFunc();
            }

            dispatch(removeIndication({ type: INDICATION_TYPES.ERROR }));

            if (isMultiLayerDrawerEnabled) {
                pop(null);
                return;
            }

            navigate(path);
        },
        [dispatch, gtmCallback, path, navigate, isMultiLayerDrawerEnabled, pop]
    );

    return handleNavigation;
};
